// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ac","header":"ae","title":"af","subHeader":"ah","footer":"ai"};